import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { map } from "lodash";
import { Card, Row, Col, Tabs, Tab } from "react-bootstrap";
import { push } from "store/actions/router";
import { capitalCase } from "change-case";

import EntityLimits from "./EntityLimits";
import EntityPayrollDetails from "./EntityPayrollDetails";

const AVAILABLE_TABS: Record<string, string> = {
  LIMITS: "limits",
  PAYROLLS: "payrolls",
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = { push };

const connector = connect(mapStateToProps, mapDispatchToProps);

// `client` is injected by withApollo but never read in this component.
type Props = WithApolloClient<ConnectedProps<typeof connector>>;

const SystemLimits = ({ push }: Props) => {
  const { pathname: routeName } = useLocation();
  const tabs = Object.keys(AVAILABLE_TABS).map((key) => {
    return { label: capitalCase(key), id: AVAILABLE_TABS[key] };
  });
  const [content, setContent] = useState<React.ReactNode>();
  const [activeTab, setActiveTab] = useState("limits");

  function getActiveTab(routeName: string) {
    switch (routeName) {
      case "/security/limits":
        return "limits";
      case "/security/payrolls":
        return "payrolls";
      default:
        return "limits";
    }
  }
  useEffect(() => {
    const newTab = getActiveTab(routeName);
    setActiveTab(newTab);
    function getContent() {
      switch (newTab) {
        case AVAILABLE_TABS.LIMITS:
          return <EntityLimits entityType="SYSTEM" />;
        case AVAILABLE_TABS.PAYROLLS: {
          return <EntityPayrollDetails />;
        }
        default:
          return <EntityLimits entityType="SYSTEM" />;
      }
    }
    setContent(getContent());
  }, [routeName]);

  const tabComponents = (
    <Tabs
      activeKey={activeTab}
      id="tab-transaction"
      onSelect={(k) => {
        push(`/security/${k}`);
      }}
    >
      {map(tabs, (tab) => {
        return <Tab key={tab.id} eventKey={tab.id} title={tab.label} />;
      })}
    </Tabs>
  );

  return (
    <div className="mega-container">
      <section className="page-title-wrap">
        <article className="text-cell">
          <h1 className="page-title">Security</h1>
          <div className="main-content">
            <Row>
              <Col>
                <div className="card-tab">{tabComponents}</div>
                <Card>
                  <Card.Body>{content}</Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </article>
      </section>
    </div>
  );
};

export default connector(withApollo<Props>(SystemLimits));
